/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeFolderTrees.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *  
 *  Created:    Wednesday, March 20, 2019 - 11:33 AM (CST)
 *  
 *  Notes:
 *  
 *  
 *  Revisions:
 *      03/20/2019  NJN     File Created
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const CMS_OPEN_CMSSELECT = 'CMS_OPEN_CMSSELECT';
export const CMS_CLOSE_CMSSELECT = 'CMS_CLOSE_CMSSELECT';
export const CMS_LOAD_CMSSELECT = 'CMS_LOAD_CMSSELECT';
export const FOLDER_CONTENTS_LOADED = 'FOLDER_CONTENTS_LOADED';


// WEBPACK FOOTER //
// ./src/constants/actionTypeFolderTrees.js